export default {"button":"nQhIu","--mobileSmall":"xtemY"};